import { ReactElement } from "react";
import styled from "styled-components";

const Page = styled.main`
  align-items: center;
  background: #fff;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  text-align: center;
`;

const Code = styled.p`
  color: #999999;
  font-size: 72px;
  font-weight: 700;
  line-height: 1;
  margin: 0;

  @media (max-width: 480px) {
    font-size: 56px;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin: 16px 0 8px;

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const Description = styled.p`
  color: #666666;
  font-size: 16px;
  margin: 0;
  max-width: 420px;
`;

/**
 * Exibida quando o dominio acessado nao corresponde a nenhuma franquia ativa.
 * Proposital nao ter marca: o dominio pode continuar resolvendo por DNS depois
 * da desativacao, e a pagina nao deve associar a marca a uma franquia inativa.
 */
export function NotFound(): ReactElement {
  return (
    <Page>
      <Code>404</Code>
      <Title>Página não encontrada</Title>
      <Description>O endereço acessado não está disponível.</Description>
    </Page>
  );
}
